import React, { useCallback, useEffect, useState } from 'react'
import '../css/WorkContainer.css'
import GitHubIcon from '@material-ui/icons/GitHub';
import WebIcon from '@material-ui/icons/Web';
import ImageViewer from "react-simple-image-viewer";
import gsap from 'gsap/gsap-core';
import { Bounce } from 'gsap/gsap-core';


function WorkContainer({ workImage, workHeading, gitLink, webLink }) {
    const [currentImage, setCurrentImage] = useState(0);
    const [isViewerOpen, setIsViewerOpen] = useState(false);
    const images = [
        workImage
    ];

    const openImageViewer = useCallback((index) => {
        setCurrentImage(index);
        setIsViewerOpen(true);
    }, []);

    const closeImageViewer = () => {
        setCurrentImage(0);
        setIsViewerOpen(false);

    };



    return (
        <div className='work-wrapper'>
            <h3>{workHeading}</h3>
            {images.map((src, index) => (
                <img src={images} alt={workHeading} className='image' onClick={() => openImageViewer(index)} key={index} ></img>
            ))}
            <div className='links-container'>
                {gitLink ? <a href={gitLink} target='_blank' >
                    <GitHubIcon id='work-links' />
                </a>
                    : null}
                {webLink ? <a href={webLink} target='_blank' >
                    <WebIcon id='work-links' />
                </a> : null}

            </div>
            <div id='image-show'>
                {
                    isViewerOpen && (
                        <ImageViewer
                            src={images}
                            currentIndex={currentImage}
                            onClose={closeImageViewer}
                            backgroundStyle={{
                                backgroundColor: "rgba(0,0,0,0.9)"
                            }}

                        />
                    )
                }
            </div>
        </div>
    )
}

export default WorkContainer
